<div class="divider-container" *ngIf="!hide">
	<div class="wrapper">
		<div class="divider"></div>
	</div>
</div>
